<template>
    <section class="modal-mask superadmin-modal modal-manage-filters">
        <div class="modal-mask-inner" @click="closeOpenModal"></div>
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="title">{{ 'filters-from-q.manage-title' | lang }}</div>

                <div class="font-14">{{ 'filters-from-q.manage-info' | lang }}</div>
                <div class="font-14 text-deep-purple">{{ 'filters-from-q.manage-info-purple' | lang }}</div>

                <div class="create-filter-options">
                    <div class="font-16">
                        <b>{{ 'filters-from-q.manage-preloaded-filters-title' | lang }}</b>
                    </div>

                    <div class="create-filter-answers">
                        <div v-for="filter in preloaded" class="create-filter-answer">
                            <label class="ed-label-with-checkbox font-16">
                                <input
                                    type="checkbox"
                                    @click="filter.visibility.results = !filter.visibility.results"
                                    :checked="filter.visibility.results"
                                />
                                <span class="ed-check-block"></span>
                                <div v-html="getTranslationIfHasAny(filter)" class="filter-name"></div>
                            </label>
                        </div>
                        <div v-if="!preloaded.length" class="create-filter-answer">{{ 'filters-from-q.no-available-filters' | lang }}</div>
                    </div>

                    <div class="font-16">
                        <b>{{ 'filters-from-q.manage-filters-from-q-filters-title' | lang }}</b>
                    </div>

                    <div class="create-filter-answers">
                        <div v-for="filter in fromQuestions" class="create-filter-answer">
                            <label class="ed-label-with-checkbox font-16">
                                <input
                                    type="checkbox"
                                    @click="filter.visibility.results = !filter.visibility.results"
                                    :checked="filter.visibility.results"
                                />
                                <span class="ed-check-block"></span>
                                <div v-html="getTranslationIfHasAny(filter)" class="filter-name"></div>
                            </label>
                        </div>
                        <div v-if="!fromQuestions.length" class="create-filter-answer">{{ 'filters-from-q.no-available-filters' | lang }}</div>
                    </div>

                    <div class="font-14">{{ 'filters-from-q.manage-tip' | lang }}</div>
                </div>

                <div class="actions">
                    <div @click="closeOpenModal" class="new-btn">{{ "general.cancel" | lang }}</div>
                    <div
                        @click="saveFilterChanges()"
                        :class="['new-btn', 'filled', { 'is-creating': isSaving }]"
                    >
                        <span v-if="!isSaving">{{ 'general.save' | lang }}</span>
                        <i v-else class="material-icons loading">autorenew</i>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import filtersFromQuestions from "@/mixins/filters-from-questions"

    export default {
        name: "ManageFilters",
        mixins: [filtersFromQuestions],
        data() {
            return {
                surveyPeriodId: this.$route.params.id,
                isSaving: false,
                preloaded: {},
                fromQuestions: {}
            }
        },
        created() {
            this.setupFilters()
        },
        methods: {
            setupFilters() {
                const filters = JSON.parse(JSON.stringify(this.$store.state.filters.list))
                this.preloaded = filters.filter(f => !f.question_id)
                this.fromQuestions = filters.filter(f => f.question_id)
            },
            async saveFilterChanges() {
                if (this.isSaving) return;

                const hasNoFilters = this.preloaded.length < 1 && this.fromQuestions.length < 1
                if (hasNoFilters) {
                    this.closeOpenModal();
                    return
                }

                this.isSaving = true;

                const onlyIdsAndVisibility = [this.preloaded, this.fromQuestions]
                    .flat(1)
                    .reduce((obj, filter, index) => {
                        obj[index] = {
                            id: filter.id,
                            name: filter.name,
                            visibility: filter.visibility
                        }
                        return obj
                    }, {})

                await this.updateVisibility(this.surveyPeriodId, { filters: onlyIdsAndVisibility })
                await this.reloadFilters()
                this.addNewFiltersToActive(true)
                this.closeOpenModal();
            }
        }
    }
</script>

<style scoped lang="scss">
    @mixin font-16 {
        font-size: 16px;
        line-height: 24px;
    }

    .modal-manage-filters {
        .font-14 {
            font-size: 14px;
            line-height: 24px;
        }

        .font-16 {
            @include font-16;
        }

        @include material-icon-loading;

        .modal-container {
            width: 560px;
            padding: 24px;
            background: #F5FBF5;
            color: #171D19;

            .title {
                padding-bottom: 24px;
                font-size: 24px;
                line-height: 32px;
                font-family: PlutoSansRegular;
                font-weight: 400;
            }

            .create-filter-options {
                margin: 0 -24px;
                padding: 24px;
                background: #F0F5EF;
            }

            .create-filter-answer {
                margin: 12px 0;
                padding: 16px 24px;
                background: #F5FBF5;
            }

            .ed-label-with-checkbox > input:checked + .ed-check-block {
                background: #226A4C;
                border-color: #226A4C;
            }

            .ed-check-block {
                margin-right: 16px;
            }

            .filter-name {
                color: #171D19;
            }

            .new-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 84px;
                margin-left: 8px;
                padding: 10px 12px;
                border-radius: 4px;
                font-size: 14px;
                line-height: 19px;
                font-weight: 500;
                text-transform: uppercase;
                font-family: PlutoSansMedium;
                cursor: pointer;
                color: #226A4C;

                &:hover {
                    background: #e9e9e9;
                }

                &.filled:not(.is-disabled) {
                    color: #fff;
                    background: #226A4C;
                }

                &.is-creating {
                    font-size: 18px;
                    text-align: center;
                }
            }

            .actions {
                display: flex;
                justify-content: flex-end;
                margin-top: 24px;
            }
        }
    }
</style>